import { useHistory } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export const ActionCard = () => {
  const history = useHistory();
  const { showNewMessage } = useIntercom();

  return (
    <Card className="w-44">
      <CardContent className="flex flex-col gap-1 py-3">
        <Button
          variant="ghost"
          size="sm"
          className="justify-start text-warning"
          onClick={() => {
            history.push(Routes.hub);
          }}
        >
          EXIT
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="justify-start text-primary"
          onClick={() =>
            showNewMessage(`I'd like to talk to someone about Easements Data"`)
          }
        >
          ASK A QUESTION
        </Button>
      </CardContent>
    </Card>
  );
};
